exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3c422pig0vl9InLvIzqeaM{border:none;font-size:1rem;color:#2e3545;width:100%}._3c422pig0vl9InLvIzqeaM:focus{outline:none}._3c422pig0vl9InLvIzqeaM:disabled{background-color:#fff}._3OpmyvnzGle8wbPYbudvTX{padding:0.7rem}\n", ""]);

// exports
exports.locals = {
	"customInput": "_3c422pig0vl9InLvIzqeaM",
	"customButton": "_3OpmyvnzGle8wbPYbudvTX"
};